// extracted by mini-css-extract-plugin
export var cartIcon = "_og-0";
export var cartIconContainer = "_og-1";